import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'TourMonitorService',
    controller: 'tb_tour_hotel'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemPagingList',
    'GeItemById'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const TbTourHotelApi = ZJApi.defineNewApi('TbTourHotelApi', factory);

export default TbTourHotelApi;